<template>
<div>暂无站内信
  <el-button type="primary" @click="$router.push('/gocat')">回到GO车惠</el-button>
</div>
</template>

<script>
export default {
  name: 'Information'
}
</script>

<style>

</style>
